import React from "react";
import {FaRegTrashCan} from "react-icons/fa6";
import {LuDownload} from "react-icons/lu";

export default function UploadedAudio({audioFile, onDelete, processed}) {
    const handleDownload = () => {
        if (audioFile) {
            const url = URL.createObjectURL(audioFile);
            const a = document.createElement("a");
            a.href = url;
            a.download = audioFile.name;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }
    };

    return (
        <div className="w-full flex flex-row justify-between items-center gap-2">
            <div className="w-full flex flex-row justify-start items-center gap-2">
                <span className="px-3 py-1 rounded-lg bg-purple-100 text-purple-700 text-[12px] font-light cursor-default select-none">
                    {audioFile ? audioFile.name : "No file selected"}
                </span>
            </div>
            <div className="w-full flex flex-row justify-end items-center gap-4">
                {audioFile && (
                    <button onClick={handleDownload} aria-label="Download file">
                        <LuDownload className="h-4 w-4 cursor-pointer hover:text-indigo-500" />
                    </button>
                )}
                {audioFile && !processed && (
                    <button onClick={onDelete} aria-label="Delete file">
                        <FaRegTrashCan className="h-4 w-4 cursor-pointer hover:text-red-500" />
                    </button>
                )}
            </div>
        </div>
    );
}
